import { useHasPermissions } from '@/components/OPermission/OPermission'
import { ROLE_GENERAL } from '@/components/OPermission/PlanPermission'
import OrbitAvatar from '@/components/OrbitAvatar'
import { leaveProject } from '@/services/member/member'
import { getOrganizationList, leaveOrganization } from '@/services/organization/organization.service'
import { getProjects } from '@/services/project/project'
import { ExclamationCircleOutlined, SettingOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Button, Dropdown, Input, List, Typography, notification } from 'antd'
import modal from 'antd/es/modal'
import React, { memo, useMemo, useState } from 'react'
import { Link, useMatch, useNavigate } from 'react-router-dom'

const serviceDict = {
  projects: getProjects,
  organizations: getOrganizationList,
}

export default memo(function UserProfileItem() {
  const match = useMatch('/home/:sourceType')
  const sourceType = match?.params.sourceType
  const { data = [], run: refresh } = useRequest(serviceDict[sourceType!], {
    refreshDeps: [sourceType]
  })
  const [text, setText] = useState('');
  const hasPlanPermission = useHasPermissions()
  const navgate = useNavigate()

  const isOrg = sourceType === 'organizations'

  const fiteredData = useMemo(() => {
    if (!text) return data
    return (data as any[]).filter(item => (item.name || '').toLowerCase().includes(text.toLowerCase()))
  }, [data, text])

  const navToProject = (id: number) => {
    if (!hasPlanPermission(ROLE_GENERAL)) {
      notification.warning({
        message: 'You need a subscription to visit the project.'
      })
      return;
    }
    
    navgate(`/main/projects/${id}`)
  }

  const items = [
    {
      key: 'leave',
      label: 'Leave',
    },
  ];

  const onActionClick = (info: { key: string }, item: any) => {
    if (info.key === 'leave') {
      modal.confirm({
        title: 'Confirm',
        icon: <ExclamationCircleOutlined />,
        content: `Are you sure to leave ${item.name}?`,
        okText: 'Yes',
        cancelText: 'No',
        onOk: async () => {
          if (!isOrg) {
            await leaveProject(item.id)
          } else {
            await leaveOrganization(item.id)
          }
          refresh()
        },
      });
    }

  }
  
  return (
    <div>
      <Input style={{ width: 300 }} placeholder='Filter by name' onChange={e => setText(e.target.value)} />
      <List
        className='mt-2'
        size='large'
        bordered
        dataSource={fiteredData as any[]}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={<OrbitAvatar size={40} avatar={item.avatar} name={item.name} />}
              title={
                <div>
                  {!isOrg && <>
                    <Button
                      type='link'
                      target='_blank'
                      onClick={() => {
                        navToProject(item.id)
                      }}
                    >{item.orgName} / {item.name}</Button>
                    <Typography.Text type='secondary' className={'ml-1'}>
                      {item.code}
                    </Typography.Text>
                  </>}
                  {isOrg && <>
                    <Link to={`/${item.id}`} target='_blank'>
                      {item.name}
                    </Link>
                  </>}
                </div>
              }
              description={item.description}
            />
            <div>
              <Dropdown menu={{ items, onClick: (info) => {
                onActionClick(info, item)
              } }}>
                <SettingOutlined />
              </Dropdown>
            </div>
          </List.Item>
        )}
      />
    </div>
  )
})
